export default __webpack_public_path__ + "static/media/100.c7079976.svg";